import { parsePhoneNumberWithError, getCountryCallingCode } from 'libphonenumber-js';

// Utility function to get country name from phone number
export const getCountryFromNumber = (phoneNumber) => {
  try {
    const parsed = parsePhoneNumberWithError(phoneNumber);
    if (parsed && parsed.country) {
      return parsed.country;
    }
  } catch (error) {
    console.warn('Failed to parse phone number:', phoneNumber, error);
  }
  
  return "US";
};

export const countryOptions = [
  {
    value: "US",
    name: `US (+${getCountryCallingCode("US")})`,
  },
];


// Search criteria options
export const searchCriteriaOptions = [
  { value: "", name: "Select Criteria" },
  { value: "number", name: "Local" },
];

// Match to options
export const matchToOptions = [
  { value: "", name: "Select Part Of Number" },
  { value: "first", name: "First part of Number" },
  { value: "anywhere", name: "Anywhere in Number" },
  { value: "last", name: "Last part of Number" },
];
